import styled from "styled-components";
import { COLORS } from "../../../constants";

const SeparatorLine = styled.hr`
  height: 0; 
  border: 0; 
  border-top: 1px solid ${COLORS.PRIMARY}; 
`;

export default SeparatorLine;